import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getRoutesQueryKey, getUnfinishedRoutesMutationKey, RoutesQueryType } from '.';
import { routeService } from '../../../../application/RouteService';
import { useErrorMiddlewareOld } from '../../../../hooks/useErrorMiddlewareOld';
import { useShowSnackbarMessage } from '../../../../hooks/useShowSnackbarMessage';
import { getLastUnfinishedRouteMutationKey, searchRoutesGeneralKey } from '../../home/hooks';

export const useEndUnfinishedRoutes = () => {
  const queryClient = useQueryClient();
  const { sessionExpiredLogout } = useErrorMiddlewareOld();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isSuccess, data, error, isLoading, mutate } = useMutation(() => routeService.endUnfinishedRoutes(), {
    onMutate: () => {
      const previousObjects = queryClient.getQueryData(getRoutesQueryKey()) as RoutesQueryType;

      queryClient.setQueryData<RoutesQueryType>(getRoutesQueryKey(), (oldData) => {
        if (!oldData) return;

        oldData.pages.forEach((page) =>
          page.docs.map((route) => {
            if (route.status === `in_transit`) {
              route.status = `finished`;
            }
            return route;
          })
        );

        return oldData;
      });

      return { previousObjects };
    },
    onSuccess: (value) => {
      // Invalidates the search unfinished routes list and the last unfinished route.
      queryClient.invalidateQueries(getUnfinishedRoutesMutationKey());
      queryClient.invalidateQueries(getLastUnfinishedRouteMutationKey());
      queryClient.invalidateQueries(searchRoutesGeneralKey());
    },
    onError: (err: any, _, context) => {
      console.info(`End Unfinished Routes Error: `, err?.response);

      if (context) {
        queryClient.setQueryData(getRoutesQueryKey(), context.previousObjects);
      }

      if (err?.response?.status === 401) {
        sessionExpiredLogout();
        return;
      }

      showSnackbarMessage({
        messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
      });
    },
  });

  return {
    error: error,
    success: isSuccess,
    isLoading: isLoading,
    data: data,
    run: mutate,
  };
};
